import * as THREE from "three";
import { RTVisualizer } from "./RTVisualizer";
import { AgentEvents, BaseAgent } from "../../agents/BaseAgent";

export class NavGoalVisualizer extends RTVisualizer {
  private marker = new THREE.Group();
  private pathVisualizer = new THREE.Line(
    new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 0)]),
    new THREE.LineBasicMaterial({ color: 0xff0000 })
  );
  constructor(public agent: BaseAgent) {
    super(agent);
    const site = agent.visual.obj.parent!;
    site.add(this.marker);
    site.add(this.pathVisualizer);
    // create a simple sphere with a line shooting out of it in the z direction. line emits red light
    const sphere = new THREE.Mesh(
      new THREE.SphereGeometry(0.1),
      new THREE.MeshBasicMaterial({ color: 0xff0000 }));
    const arrow = new THREE.ArrowHelper(
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(0, 0, 0.2),
      0.5,
      0xffff00);
    this.marker.add(arrow);
    this.marker.add(sphere);

    const line = new THREE.Line(
      new THREE.BufferGeometry()
        .setFromPoints([new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 0.3)]),
      new THREE.LineBasicMaterial({ color: 0xff0000 }));
    this.marker.add(line);
    this.marker.visible = false;
    agent.on(AgentEvents.StateChange, (dgram: any) => {
      if (!dgram) {
        return;
      }
      if (dgram.navGoal) {
        const navGoal: number[] = dgram.navGoal;
        if (navGoal.length === 0) {
          this.marker.visible = false;
        } else {
          this.marker.visible = true;
          this.marker.position.set(navGoal[0], navGoal[1], navGoal[2]);
          if (navGoal.length > 3) {
            const theta = navGoal[3];
            this.marker.rotation.set(0, 0, theta);
          }
        }
      }
      if (dgram.navPath) {
        // console.log("navPath", dgram.navPath);
        this.setPath(dgram.navPath);
      }
    });
  }

  public setPath(path: number[]) {
    if (path.length < 2) {
      this.pathVisualizer.visible = false;
      return;
    }
    const points: THREE.Vector3[] = [];
    for (let i = 0; i < path.length; i += 2) {
      const z = 0;
      points.push(new THREE.Vector3(path[i], path[i + 1], z + 0.75));
    }
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    this.pathVisualizer.visible = true;
    this.pathVisualizer.geometry.dispose();
    this.pathVisualizer.geometry = geometry;
  }
}